import { InputMaybe } from '@neo.tax/shared/graphql';

/**
 * Updates the values of {@link obj} with any values in {@link inputObject}
 * which are non-null. Emulates the common pattern of an update mutation taking
 * an input object to update any or all properties. Useful for crafting an
 * optimistic response.
 *
 * Note that the input object must be the same shape as the object it updates
 * (with optional values), which is the pattern we typically use.
 */
export const updateWithInputObject = <O extends object>(
  obj: O,
  inputObject: {
    [P in keyof O]?: InputMaybe<O[P]>;
  },
): O => ({
  ...obj,
  ...inputObject,
});
